import React from "react";

import noData from "../../Assets/Images/Nodata.png";
const NodataAvailable = () => {
  return (
    <>
      <center className="row justify-content-center align-content-center my-5">
        <div className="col-md-12">
          <img src={noData} alt="" className="img-fluid" />
        </div>
      </center>
    </>
  );
};

export default NodataAvailable;
